import type { FireIconProps } from './types';

export default function FireExtinguisher({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Handle / lever */}
      <path d="M11 3h4l1 2h-5z" />
      {/* Nozzle hose */}
      <path d="M15 3c1 0 2 .5 2 1.5S16 6 15 6" />
      {/* Neck */}
      <rect x="10" y="5" width="4" height="2" rx="0.5" />
      {/* Pressure gauge */}
      <circle cx="14.5" cy="6" r="0.5" />
      {/* Body */}
      <rect x="9" y="7" width="6" height="12" rx="2" />
      {/* Label band */}
      <line x1="9" y1="11" x2="15" y2="11" />
      <line x1="9" y1="14" x2="15" y2="14" />
      {/* Base */}
      <line x1="9" y1="19" x2="15" y2="19" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="9" y1="19" x2="8" y2="21" />
      <line x1="15" y1="19" x2="16" y2="21" />
    </svg>
  );
}
